export const utilsObj = {
  getUnknownOrYesOrNo(value) {
    if (value == 0) {
      return "未知";
    } else if (value == 1) {
      return "是";
    } else {
      return "否";
    }
  },
  getYesOrNo(value) {
    if (value == 1) {
      return "是";
    } else {
      return "否";
    }
  },
  getYesOrNoEx(value) {
    if (value == 0) {
      return "是";
    } else {
      return "否";
    }
  },
  //车位等级
  carSetLev() {
    return ["A", "B", "C", "D", "E", "F"];
  },
  //根据index获取车位类型
  getCarSetLev(index) {
    let ret = "-";
    if (this.carSetLev()[index]) {
      ret = this.carSetLev()[index];
    }
    return ret;
  },
  //审核状态
  audiotState() {
    return [
      "未审核",
      "政委审核通过",
      "政委审核拒绝",
      "经理审核通过",
      "经理审核拒绝",
      "重新提交审核"
    ];
  },
  //根据index获取审核状态
  getAudiotState(index) {
    let ret = "-";
    if (this.audiotState()[index]) {
      ret = this.audiotState()[index];
    }
    return ret;
  },
  //签约状态
  signState() {
    return ["未签约", "待审核", "已签约"];
  },
  //根据index获取签约状态
  getSignState(index) {
    let ret = "-";
    if (this.signState()[index]) {
      ret = this.signState()[index];
    }
    return ret;
  },
  getD(a, b) {
    //获取两个时间相差月
    var arrA = a.split("-"),
      arrB = b.split("-"),
      yearA = arrA[0],
      yearB = arrB[0],
      monthA = +arrA[1],
      monthB = (yearB - +yearA) * 12 + parseInt(arrB[1]),
      rA = [],
      rB = [];
    do {
      do {
        rA.push(yearA + "" + (monthA > 9 ? monthA : "0" + monthA));
        rB.push(yearA + "年" + monthA + "月");
        if (monthA == 12) {
          monthA = 1;
          monthB -= 12;
          break;
        }
      } while (monthB > monthA++);
    } while (yearB > yearA++);
    return [rA, rB];
  },
  getDateFormat(dateStr) {
    if (dateStr) {
      var dateArray = dateStr.split(" ");
      return dateArray[0];
    } else {
      return "";
    }
  },
  //生成guid
  guid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  },
  //保存手机本地数据
  saveLocation(key, value) {
    SXApi.call(function(suc) {}, null, "FunctionPlugin", "save_location", {
      key: key,
      value: value
    });
  },
  //获取手机本地信息
  getLocation(key, callback) {
    SXApi.call(
      function(suc) {
        callback(suc.data.data);
      },
      function(err) {
        callback("");
      },
      "FunctionPlugin",
      "get_location",
      {
        key: key
      }
    );
  },
  //是否使用手机端
  isPhone() {
    if (navigator.userAgent.indexOf("os-name/android") == -1) {
      return false;
    } else {
      return true;
    }
  },
  //上传文件类型
  fileTypeMap() {
    return [
      { val: 6, value: "最终销售价格表" },
      { val: 8, value: "三方确认函" },
      { val: 5, value: "销售经理复盘" },
      { val: 9, value: "撤场确认函" },
      { val: 11, value: "销控图" },
      { val: 14, value: "广告策略" },
      { val: 18, value: "车位交接单" },
      { val: 27, value: "业主签约合同模板" }
    ];
  },
  //获取上传文件类型
  getNameByfileType(val) {
    let ret = "";
    let tempMap = JSON.parse(JSON.stringify(this.fileTypeMap()));
    tempMap.push({ val: 20, value: "撤场回复函" });
    tempMap.push({ val: 21, value: "居间协议" });
    tempMap.push({ val: 22, value: "同行商务条款" });
    tempMap.push({ val: -101, value: "推盘方案" });
    tempMap.push({ val: 28, value: "续签项目评估表" });
    tempMap.push({ val: 1, value: "项目分析" });
    tempMap.push({ val: 7, value: "回复函" });
    tempMap.push({ val: 2, value: "拓展复盘" });
    tempMap.push({ val: 3, value: "同行学习" });
    tempMap.push({ val: 4, value: "同行复盘" });
    tempMap.push({ val: 10, value: "数据表" });
    tempMap.push({ val: 12, value: "我方车位库存明细表" });
    tempMap.push({ val: 17, value: "甲方车位库存明细表" });
    tempMap.push({ val: 24, value: "剩余车位库存明细表" });
    tempMap.push({ val: 13, value: "承诺书" });
    tempMap.push({ val: 15, value: "我方销售台账" });
    tempMap.push({ val: 16, value: "甲方销售台账" });
    tempMap.push({ val: 19, value: "方案" });
    tempMap.push({ val: 23, value: "前期销售合同" });
    tempMap.push({ val: 25, value: "商务函" });
    tempMap.push({ val: 26, value: "业主明细" });
    tempMap.push({ val: 29, value: "车位库存明细表" });
    tempMap.push({ val: 30, value: "车位销售台账" });
    tempMap.push({ val: 31, value: "其他" });

    for (let i = 0; i < tempMap.length; i++) {
      if (val == tempMap[i].val) {
        ret = tempMap[i].value;
        break;
      }
    }
    return ret;
  },
  getMerchantAdStr(state, isRej) {
    let tempData = [
      // { text: "全部", value: null },
      { text: "发起", value: 1 },
      { text: "待确认(设计)", value: 2 },
      { text: "制作中", value: 3 },
      // { text: "待结算(撤场)", value: 4 },
      { text: "待结算(撤场)", value: 5 },
      { text: "结算待审核(经理)", value: 6 },
      { text: "结算待审核(设计)", value: 7 },
      { text: "结算待审核(总监/分总)", value: 8 },
      { text: "发票待上传", value: 9 },
      { text: "已结算", value: 10 }
    ];
    if (isRej == 1) {
      return "已拒绝";
    } else {
      let item = tempData.find(element => element.value == state);
      if (item) {
        return item.text;
      }
      return "";
    }
  },
  parkLevelMap() {
    return ["A", "B", "C", "D", "E", "F"];
  },

  //判断是否JSON
  isJSON(str) {
    if (typeof str == "string") {
      try {
        var obj = JSON.parse(str);
        if (typeof obj == "object" && obj) {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    } else {
      return false;
    }
  },
  //查询列表等级
  getLeveTypeMapForlist() {
    return [
      { text: "A落位", showLab: "A", value: 0 },
      { text: "A-小定", showLab: "A-", value: -1 },
      { text: "B+未约定好时间来", showLab: "B+", value: 1 },
      { text: "B-没有明确拒绝,但有一定意向", showLab: "B-", value: 2 },
      { text: "C明确拒绝", showLab: "C", value: 3 },
      { text: "D未联系到", showLab: "D", value: 4 },
      { text: "E未分类用户", showLab: "E", value: 5 },
      { text: "M保留", showLab: "M", value: 6 },
      // { text: "N空号、号码错误", showLab: "N", value: 7 },
      // { text: "T其他人推荐", showLab: "T", value: 8 },
      { text: "全部", value: null }
    ];
  },
  //编辑查看页面等级选择
  getLeveTypeMapForDetal() {
    return [
      { text: "A", value: "A落位", key: "0" },
      { text: "A-", value: "A-小定", key: "-1" },
      { text: "B+", value: "B+未约定好时间来", key: "1" },
      { text: "B-", value: "B-没有明确拒绝,但有一定意向", key: "2" },
      { text: "C", value: "C明确拒绝", key: "3" },
      { text: "D", value: "D未联系到", key: "4" },
      { text: "E", value: "E未分类用户", key: "5" },
      { text: "M", value: "M保留", key: "6" }
      // { text: "N", value: "N空号、号码错误" },
      // { text: "T", value: "T其他人推荐" },
    ];
  },

  getPropritorLvDataText(value) {
    let propritorLvData = this.getLeveTypeMapForDetal();
    let ret = "";
    for (let i = 0; i < propritorLvData.length; i++) {
      if (propritorLvData[i].key == value) {
        ret = propritorLvData[i].text;
        break;
      }
    }
    return ret;
  },

  //编辑查看页面等级选择
  getCommodityType(jobs) {
    let returnType = [];
    let commodityType = [
      { name: "全部", value: null },
      { name: "拓展", value: 0 },
      { name: "签约礼品", value: 1 },
      { name: "宣传礼品", value: 2 },
      { name: "金蛋礼品", value: 3 },
      { name: "经理送礼", value: 4 },
      { name: "销售日常消耗", value: 5 },
      { name: "固定资产", value: 6 },
      { name: "公司发展", value: 7 },
      { name: "其他", value: 8 },
      { name: "办公室", value: 9 },
      { name: "地锁", value: 10 }
    ];
    commodityType.forEach(element => {
      jobs.forEach(item => {
        if (item == element.value) {
          returnType.push(element);
        }
      });
    });
    return returnType;
  },
  //支付
  payJump(value, callBack) {
    SXApi.call(
      function(suc) {
        callBack && callBack(suc);
      },
      null,
      "FunctionPlugin",
      "pay",
      value
    );
  },
  getWeek(date) {
    let weeks = ["日", "一", "二", "三", "四", "五", "六"];
    let day = new Date(date || new Date()).getDay();
    if (day) {
      return "周" + weeks[day];
    } else {
      console.error("时间格式错误");
    }
  },
  //获取商品类型
  getReserveTypeName() {
    return [
      "拓展",
      "签约礼品",
      "宣传礼品",
      "金蛋礼品",
      "经理送礼",
      "销售日常消耗",
      "固定资产",
      "公司发展",
      "其他",
      "办公室",
      "地锁",
      "低值易耗品",
      "员工福利",
      "办公室消耗"
    ];
  },
  deepMerge(target, source) {
    for (const key in source) {
      if (source.hasOwnProperty(key)) {
        const sourceVal = source[key];
        const targetVal = target[key];

        if (this.isObject(sourceVal)) {
          if (Object.keys(sourceVal).length === 0) {
            // source是空对象，直接覆盖
            target[key] = {};
          } else if (this.isObject(targetVal)) {
            // source是非空对象，target也是对象，递归合并
            this.deepMerge(targetVal, sourceVal);
          } else {
            // target不是对象，直接赋值
            target[key] = sourceVal;
          }
        } else {
          // 其他类型直接覆盖
          target[key] = sourceVal;
        }
      }
    }
    return target;
  },
  isObject(obj) {
    return obj && typeof obj === "object" && !Array.isArray(obj);
  }
};



// WEBPACK FOOTER //
// ./src/commonjs/utils.js